module.exports = __webpack_public_path__ + "img/lens-174-plus-07.aa8c9c6b.png";